import React from 'react';
import Descriptions from 'antd/es/descriptions';
import { AuthenticatedContextType } from '../../context/AuthenticatedContext';
import {
  contentHeight100,
  contentStyle,
  dataDispWidth,
  labelStyle,
  userContentStyle,
  userLabelStyle,
} from '../../css/style';
import { dateformat } from '../date-range';
import DeviceTrouble from '../../models/data/DeviceTrouble';

interface DataProps {
  userdata: AuthenticatedContextType;
  data: DeviceTrouble | undefined;
}

const DataDisp: React.FC<DataProps> = ({ userdata, data }) => {
  const customerName = userdata.loginCustomer?.customerName ?? '';
  const corporateCode = userdata.loginCustomer?.corporateCode ?? '';

  return (
    <div>
      {/* ユーザ情報 */}
      <Descriptions
        bordered
        column={3}
        labelStyle={userLabelStyle}
        contentStyle={userContentStyle}
        style={{ marginBottom: '10px', width: dataDispWidth.userInfo }}
      >
        <Descriptions.Item label="ユーザ名" span={3}>
          {`${corporateCode} ◇ ${customerName}`}
        </Descriptions.Item>
      </Descriptions>
      {/* ID */}
      <Descriptions
        bordered
        column={2}
        contentStyle={contentStyle}
        labelStyle={labelStyle}
        style={{
          marginBottom: '10px',
          width: dataDispWidth.deviceTroubleDetail900,
        }}
      >
        <Descriptions.Item label="修理ID" span={1}>
          {data?.troubleId ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="機器ID" span={1}>
          {data?.trMstId ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="工号" span={1}>
          {data?.trJobNo ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="発生日" span={1}>
          {dateformat(data?.trDate)}
        </Descriptions.Item>
        <Descriptions.Item label="修理内容" span={2}>
          {data?.trSummary ?? ''}
        </Descriptions.Item>
      </Descriptions>
      <Descriptions
        // title=""
        bordered
        column={1}
        contentStyle={contentStyle}
        labelStyle={labelStyle}
        style={{
          marginBottom: '10px',
          width: dataDispWidth.deviceTroubleDetail450,
        }}
      >
        <Descriptions.Item
          label="症状"
          span={1}
          contentStyle={{ ...contentStyle, ...contentHeight100 }}
        >
          {data?.coOther ?? ''}
        </Descriptions.Item>
        <Descriptions.Item
          label="原因"
          span={1}
          contentStyle={{ ...contentStyle, ...contentHeight100 }}
        >
          {data?.caOther ?? ''}
        </Descriptions.Item>
        <Descriptions.Item
          label="処置"
          span={1}
          contentStyle={{ ...contentStyle, ...contentHeight100 }}
        >
          {data?.diOther ?? ''}
        </Descriptions.Item>
      </Descriptions>
      {/* その他 */}
      <Descriptions
        bordered
        column={1}
        labelStyle={userLabelStyle}
        contentStyle={userContentStyle}
        style={{
          marginBottom: '10px',
          width: dataDispWidth.deviceTroubleDetail450,
        }}
      >
        <Descriptions.Item label="使用部品" span={1}>
          {data?.trParts}
        </Descriptions.Item>
        <Descriptions.Item label="備考" span={1}>
          {data?.trPending}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default DataDisp;
